import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from "../Component/Header";
const SchoolCalendar = () => {
    useEffect(() => {
        document.title = 'School Calendar -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li> Academics  </li> 
                 <li>School Calendar  </li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> School Calendar  </h1>
                    </div>
                </div>
                <div className="row">
                <div className="col-lg-6">
                            <div className="linktab"> <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/SeniorWing.pdf" target="_blank"> Senior Wing
                            </Link> </div>
                    </div>
                    <div className="col-lg-6">
                            <div className="linktab"> <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/JuniorWing.pdf" target="_blank"> Junior Wing
                            </Link> </div>
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default SchoolCalendar